import { createAction, props } from '@ngrx/store';
import { UserSettings } from '../services/auth/user.service';

export const loadedUserSettings = createAction('[User Settings/API] Loaded User Settings Success', props<{ settings: UserSettings }>());

export const loadUserSettings = createAction('[User Settings/API] Load User Settings');

export const removeUserSettings = createAction('[User Settings/API] Remove User Settings');
